module.exports = "<button class=\"btn btn-primary\">\r\n    <span translate>Select Asset(s)</span>\r\n</button>";